import PropTypes from 'prop-types';
import React from 'react';

import {
  normalDelimiter,
  normalNonBreakingDelimiter,
  narrowNonBreakingDelimiter,
} from './helpers/delimiters';
import { formatPeriod, formatPeriodToObject, defaultOptions } from './helpers/formatPeriod';

class FormattedPeriod extends React.PureComponent {
  static propTypes = {
    startDate: PropTypes.instanceOf(Date).isRequired,
    endDate: PropTypes.instanceOf(Date).isRequired,
    foldSameYear: PropTypes.bool,
    // false: 10 июня - 11 июня
    // true: 10 - 11 июня
    foldSameMonth: PropTypes.bool,
    foldSameDate: PropTypes.bool,
    isShortMonth: PropTypes.bool,
    showYear: PropTypes.bool,
    hideCurrentYear: PropTypes.bool,
    showWeekdays: PropTypes.bool,
  };

  static defaultProps = defaultOptions;

  constructor(props, ctx) {
    super(props, ctx);
  }

  render() {
    const { className, style } = this.props;

    const formattedPeriod = formatPeriod(this.props);

    return (
      <span data-locator="FormattedPeriod" className={className} style={style}>
        {formattedPeriod}
      </span>
    );
  }
}

export default FormattedPeriod;

export {
  normalDelimiter,
  normalNonBreakingDelimiter,
  narrowNonBreakingDelimiter,
  formatPeriod,
  formatPeriodToObject,
};
